import { useUser } from 'Core/Hooks/useUser'
import { FullScreenContentModal } from 'V2Components'
import { getHTMLDataTestID } from 'infra/utils'
import { Button, Label, LoadingSpinner, TargetIcon, TextInput, Typography } from 'procyon-ui'
import React, { useState } from 'react'

const Slack = ({ onInputChange, onContinue, message, onCancel, nameError, isDisabled }) => {
  const { controller } = useUser()

  const handleBotRedirection = () => {
    if (controller === 'staging.proxyon.cloud') {
      window.open(
        'https://slack.com/oauth/v2/authorize?client_id=2969919076628.2964848690821&scope=channels:read,chat:write,commands,groups:read,mpim:read&user_scope=',
        '_blank'
      )
    } else {
      window.open(
        'https://slack.com/oauth/v2/authorize?client_id=2969919076628.3869369921633&scope=channels:read,chat:write,commands,groups:read,mpim:read&user_scope=',
        '_blank'
      )
    }
  }

  return (
    <FullScreenContentModal width='660px'>
      <div className='flex justify-between items-center'>
        <Typography variant='title-regular' className='flex text-2xl items-center font-bold'>
          <TargetIcon
            width={'48px'}
            height={'48px'}
            type={'SLACK'}
            className='rounded'
            style={{
              borderRadius: '12px',
              marginRight: '15px'
            }}
          />
          Setup Slack Integration
        </Typography>
        {/* <div>
          <Button
            variant='primary'
            data-testid={getHTMLDataTestID('integration', 'button', 'integrate-bot')}
           id='integrate-button' onClick={() => handleBotRedirection()}>Integrate BOT</Button>
        </div> */}
      </div>
      {!message ? (
        <>
          <div className='p-4 mt-2 rounded text-black max-h-[60vh] w-[100%] flex flex-col'>
            <TextInput
              data-testid={getHTMLDataTestID('integration', 'input', 'name')}
              id='integration-name'
              label='Integration Name'
              onChange={(e) => onInputChange(e.target.value, 'name')}
              placeholder='Please enter name'
              style={{
                width: '100%',
                marginBottom: '10px'
              }}
            />

            <TextInput
              data-testid={getHTMLDataTestID('integration', 'input', 'webhookUrl')}
              id='webhook-url'
              label='WebHook Url'
              onPaste={(e) => {
                const pastedText = e.clipboardData.getData('text')
                onInputChange(pastedText, 'webhookUrl')
              }}
              onChange={(e) => {
                onInputChange(e.target.value, 'webhookUrl')
              }}
              placeholder='URL'
              style={{
                width: '100%'
              }}
            />
          </div>

          <div className='flex justify-between px-4 items-center'>
            <div>{nameError !== '' ? <Label variant='warning' text={nameError} /> : null}</div>
            <div className='flex justify-end mt-2 gap-4'>
              <Button
                data-testid={getHTMLDataTestID('integration', 'button', 'cancel')}
                id='cancel-button'
                size='md'
                onClick={onCancel}
                variant='gray'
              >
                Cancel
              </Button>
              <Button
                data-testid={getHTMLDataTestID('integration', 'button', 'continue')}
                id='continue-button'
                disabled={isDisabled}
                size='md'
                onClick={onContinue}
                variant='primary'
              >
                Continue
              </Button>
            </div>
          </div>
        </>
      ) : (
        <div className='flex items-center bg-[#f2f4fb] p-5 mt-5'>
          <div className='mt-2'>
            <LoadingSpinner size={20} thickness={4} />
          </div>
          <Label text={message} variant='grayBlue' />
        </div>
      )}
    </FullScreenContentModal>
  )
}

export { Slack }
